import { LOCALIZE_NAME_OPTIONS } from "~/constans/commom";

export const openEditModal_DefaultTableRow =
  (type, item, setData, history) => () => {
    if (type === "report_list") {
      setData("reportId", item.id, "openModal", "Edit");
      return;
    }
    if (type === "patp") {
      history.push(`/editor/cep/ptp/${item.instanceId}`);
      return;
    }
    if (type === "positionDirectory" || type === "information_system") {
      return setData("openModal", "Edit", "currentId", item.id);
    }
    if (type !== "employee" && type !== "positionDirectory") {
      if (type === "cep.courses_table") {
        return setData("openModal", "Edit", "currentId", item.instanceId);
      }
      return type !== "employee"
        ? setData("openModal", "Edit", "currentId", item.id)
        : history.push(`${item.id}`);
    }
    if (type === "employee") {
      history.push(`${item.id}`);
    }
  };

export const openViewModal_DefaultTableRow =
  (type, item, setData, history) => () => {
    if (type === "personal_data" || type === "information_system") {
      return setData("openModal", "View", "currentId", item.id);
    }
    if (type === "patp") {
      history.push(`/editor/cep/view/ptp/${item.instanceId}`);
      return;
    }
    if (type !== "employee") {
      return type === "announcement"
        ? history.push(`/announcement/viewing/${item.id}`)
        : setData("openChildModal", "View", "currentId", item.id);
    }
    if (type === "employee") {
      return history.replace(`/base/viewing/${item.id}`);
    }
  };

export const openEditStatusModal_DefaultTableRow = (setData, item) => () =>
  setData("openModal", "EditStatus", "currentId", item.id);

export const openDelModal_DefaultTableRow = (setData, item, type) => () => {
  if (type === "domains_table") {
    return setData(
      "currentId",
      item.id,
      "status",
      "delete",
      "name",
      item.domain
    );
  }
  setData("openModal", "Sure", "currentId", item.id);
};

export const openRestoreModal_DefaultTableRow = (setData, item) => () => {
  setData("openModal", "Restore", "currentId", item.id);
};

// LOGICAL CHECKS

export const isAnnouncementTitle_DefaultTableRow = (optionName, type) =>
  type === "announcement" && optionName === "title";
export const isAnnouncementSignedBy_DefaultTableRow = (optionName, type) =>
  type === "announcement" && optionName === "singedBy";
export const isImportanceBoth_DefaultTableRow = (optionName, type) =>
  (type === "announcement" || type === "documents.table") &&
  optionName === "importance";
export const isSortActive_DefaultTableRow = (
  optionName,
  sortField,
  type,
  commonName,
  lang
) =>
  sortField ===
  (type === "indicators"
    ? optionName === "name"
      ? commonName
      : optionName
    : LOCALIZE_NAME_OPTIONS.includes(optionName) && lang === "en"
    ? `${optionName}En`
    : optionName);
export const isUsersRemoved_DefaultTableRow = (item, type) =>
  type === "users" && item.status === "removed";
export const isTrTitle_DefaultTableRow = (optionName, type) =>
  (type === "announcement" || type === "documents.table") &&
  (optionName === "title" || optionName === "singedBy");
export const isTdStatus_DefaultTableRow = (optionName, type) =>
  type === "announcement" && optionName === "status";
export const isCoursesTableCell_DefaultTableRow = (optionName, type) =>
  (optionName === "name" && type === "cep.courses_table") ||
  type === "documents.table";
